import { axiosInstance } from "../axiosUtil";

export const validateEmailToken = (token) => {
  return axiosInstance
    .post(`/auth/password_reset/validate_token/`, {
      token: token,
    })
    .then((response) => {
      return response;
    });
};

export const resetPassword = (token, password) => {
  return axiosInstance
    .post(`/auth/password_reset/confirm/`, {
      token: token,
      password: password,
    })
    .then((response) => {
      return response;
    });
};

export const sendResetLink = (email) => {
  return axiosInstance
    .post(`auth/password_reset/`, {
      email: email,
    })
    .then((response) => {
      return response;
    });
};
